// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import v4 from 'uuid/v4';

import { basketOutcomeSelected, basketOutcomeUnselected } from '../../actions/basket';
import useMergeProps from '../../hooks/useMergeProps';
import useShallowEqualSelector from '../../hooks/useShallowEqualSelector';
import { type CardMode } from '../../types/common';

import makeBoostedOddCardPropsSelector from './BoostedOddCard.selector';

import BoostedOddCard from '.';

type BoostedOddCardContainerPropsType = {
  matchId: number;
  cardMode: CardMode | null;
  isLive: boolean | null;
  showFavorite: boolean;
  isFavorite: boolean;
  onFavoriteButtonClicked: (...params: unknown) => unknown;
};

const BoostedOddCardContainer = (ownProps: BoostedOddCardContainerPropsType) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const selectorProps = useMemo(() => ({ ...ownProps, pathname: location.pathname }), [location, ownProps]);
  const selector = useMemo(() => makeBoostedOddCardPropsSelector(), []);
  const selectedProps = useShallowEqualSelector((state) => selector(state, selectorProps));

  const uuid = useMemo(() => v4(), []);

  const onClick = useCallback(
    (matchId, betId, oddId, selected) => {
      if (selected) {
        dispatch(basketOutcomeUnselected({ oddId, matchId, sourceElementUuid: uuid, betId }));
      } else {
        dispatch(basketOutcomeSelected({ oddId, matchId, sourceElementUuid: uuid, betId }));
      }
    },
    [dispatch, uuid],
  );

  const otherProps = useMemo(
    () => ({
      uuid,
      onClick,
    }),
    [uuid, onClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <BoostedOddCard {...enhancedProps} />;
};

export default BoostedOddCardContainer;
